export default __webpack_public_path__ + "static/media/POSTER 1.f1fda7ee.JPG";